<app-label-configuration
  [title]="'P0003605.installation.regulation' | translate"
  [titleListe]="'P0003605.installation.regulation.redox' | translate"
  [value]="actionStack!.getValue('icPConsigneRegulationRx')"
  [liste]="P0003605ConsigneRegulationRxEnum"
  [information]="P0003605ESPInstallationCl"
  (onPress)="
    actionStack!.editValue(
      P00039DataRxTxIndex.InjectionChlore_Parametrage,
      'icPConsigneRegulationRx',
      $event
    );
    actionStack!.commit()
  "
>
</app-label-configuration>

<app-label-configuration
  [titleListe]="'P0003605.configuration.hyteresis' | translate"
  [value]="actionStack!.getValue('icPHysteresisRegulationRx')"
  [liste]="P0003605HysteresisRegulationRx"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.InjectionChlore_Parametrage,
      'icPHysteresisRegulationRx',
      $event
    );
    actionStack!.commit()
  "
>
</app-label-configuration>

@if (
  hasProduitP0003600() > 0 ||
  hasProduitP0003601() > 0 ||
  hasProduitP0004700() > 0 ||
  hasProduitP00046() > 0
) {
  <app-switch-configuration
    [nameCustom]="'P0003605.installation.filtration.value' | translate"
    [value]="actionStack!.getValue('icIActivationFonctionAutoMaintien') !== 0"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionChlore_Installation,
        'icIActivationFonctionAutoMaintien',
        $event ? 1 : 0
      );
      actionStack!.commit()
    "
  >
  </app-switch-configuration>
}

<app-label-description
  [description]="'P0003605.installation.regulation.description' | translate"
></app-label-description>

<app-label-configuration
  [title]="'P0003605.parametre.hivernage' | translate"
  [titleListe]="'P0003605.parametre.hivernage.value' | translate"
  [value]="actionStack!.getValue('icPDureeMaximumQuotidienne')"
  [liste]="P0003605DureeQuotidienneInjection"
  [description]="'P0003605.parametre.hivernage.description' | translate"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.InjectionChlore_Parametrage,
      'icPDureeMaximumQuotidienne',
      $event
    );
    actionStack!.commit()
  "
>
</app-label-configuration>

<app-switch-configuration
  [title]="'P0003605.parametre.securite' | translate"
  [nameCustom]="'P0003605.parametre.securite.value' | translate"
  [value]="actionStack!.getValue('icIActivationProtectionSurdosage') !== 0"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.InjectionChlore_Installation,
      'icIActivationProtectionSurdosage',
      $event ? 1 : 0
    );
    actionStack!.commit()
  "
>
</app-switch-configuration>

@if (this.actionStack!.getValue('icIActivationProtectionSurdosage') === 1) {
  <app-label-configuration
    [titleListe]="'P0003605.parametre.duree' | translate"
    [value]="actionStack!.getValue('icPDureeLimiteSurdosage')"
    [liste]="P0003605DureeLimiteSurdosage"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionChlore_Parametrage,
        'icPDureeLimiteSurdosage',
        $event
      );
      actionStack!.commit()
    "
  >
  </app-label-configuration>
}

<app-label-description
  [description]="'P0003605.parametre.securite.description' | translate"
></app-label-description>

@if (isSupportTechnique()) {
  <app-switch-configuration
    [title]="'P0003605.parametre.desinfection' | translate"
    [nameCustom]="'P0003605.parametre.desinfection.value' | translate"
    [description]="'P0003605.parametre.desinfection.description' | translate"
    [value]="actionStack!.getValue('icPActivationSecuriteDesinfection') !== 0"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionChlore_Parametrage,
        'icPActivationSecuriteDesinfection',
        $event ? 1 : 0
      );
      actionStack!.commit()
    "
  >
  </app-switch-configuration>
}
